import { BaseBus } from "./BaseBus";
export class DomainDetBus extends BaseBus

{

    constructor() {
        super();
        //    if (data !== null) {
        //        this.set(data.type, data.name, data.nameDescription, data.descriptionDescription);
        //    }
    }
    public id: string;
    public name: string;
    public isActive: boolean;
    public co: string;
    public bool1: boolean;

}